import React from 'react'
import { Button } from 'reactstrap'
import LoadingPage from './LoadingPages'
import { isChunkLoadError, hasAlreadyAttemptedChunkReload, attemptChunkReload } from '../../helpers/chunkErrorRecovery'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, isChunkError: false, alreadyAttempted: false }
    }

    static getDerivedStateFromError(error) {
        const isChunkError = isChunkLoadError(error)
        const alreadyAttempted = isChunkError && hasAlreadyAttemptedChunkReload()
        return { hasError: true, isChunkError, alreadyAttempted }
    }

    componentDidCatch(error, info) {
        console.error(error, info)
        if (this.state.isChunkError && !this.state.alreadyAttempted) {
            attemptChunkReload()
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.state.isChunkError && !this.state.alreadyAttempted) {
                return <LoadingPage />
            }
            return (
                <div style={{ height: '100vh', width: '100%' }} className="d-flex flex-column justify-content-center align-items-center">
                    <p className="mb-3">Une erreur est survenue. Merci de recharger la page.</p>
                    <Button color="primary" onClick={() => window.location.reload()}>Recharger la page</Button>
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
